import { useFlags } from "@/utils/flagsmith/useFlags";
import { useApiQuery } from "@/api/hooks/useApiQuery";
import { DetailTableRow } from "../../components/DetailTable";
import { COMING_SOON } from "@/entities/CreditBox/CreditBox.types";
import { getCompany } from "@/entities/Company/Company.queries";
import {
    CompanyEquityRaised,
    EQUITY_RAISED,
} from "@/entities/CapitalApplication/CapitalApplication.constants";
import { createMetricLabel } from "../../helpers/labelHelpers";
import { DataSource } from "../../components/SourceTag";

export function useCapitalStructureData(): DetailTableRow[] {
    const flags = useFlags();
    const showComingSoonFields = flags.enabled("show-coming-soon-placeholders");

    const company = useApiQuery(getCompany);

    const totalEquityRaised = company.data?.capitalApplication.equityRaised;

    const totalEquityRaisedValue =
        (totalEquityRaised &&
            EQUITY_RAISED[totalEquityRaised as CompanyEquityRaised]) ||
        "-";

    return [
        ...(showComingSoonFields
            ? [
                  {
                      label: "Senior Debt",
                      value: COMING_SOON,
                  },
              ]
            : []),

        {
            label: createMetricLabel(
                "Total Equity Raised",
                "self_reported_company_data",
            ),
            value: totalEquityRaisedValue,
            source: DataSource.LEGACY_BACKEND,
            fieldName: "company.capitalApplication.equityRaised",
            onClick: () => {},
        },

        ...(showComingSoonFields
            ? [
                  {
                      label: "Junior Debt",
                      value: COMING_SOON,
                  },
              ]
            : []),
    ];
}
